export enum TEMPLATE_TYPES {
	PRIVATE = 'private',
	WORKSHOP = 'workshop',
}
